import { createSlice } from "@reduxjs/toolkit";
import {
  addConfigAttributes,
  fethConfigAttributes,
  fetchConfigById,
  updateConfigAttributes,
  updateStatusInConfigAttributes,
} from "./thunk";

interface CategoryState {
  configAttributeList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
  
}

const initialState: CategoryState = {
  configAttributeList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "configAttribute",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fethConfigAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fethConfigAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.configAttributeList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fethConfigAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchConfigById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConfigById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchConfigById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addConfigAttributes.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.configAttributeList = state.configAttributeList.map((config_attribute) =>
          config_attribute.id === action.payload.id ? action.payload : config_attribute
        );
      })
      .addCase(addConfigAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateConfigAttributes.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.configAttributeList = state.configAttributeList.map((config_attribute) =>
          config_attribute.id === action.payload.id ? action.payload : config_attribute
        );
      })
      .addCase(updateConfigAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInConfigAttributes.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInConfigAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
